// Date formats that exist for Meta-v2
module.exports = {
  dateFormatsList: ['DDMMYYYY', 'MMDDYYYY'],
  defaultDateFormat: 'DDMMYYYY',
};
